const shouldForwardProp = (name: string) => {
  const propsSet = new Set([
    'alignCenter',
    'alignItems',
    'backgroundColor',
    'bordered',
    'color',
    'direction',
    'gap',
    'gapColumn',
    'gapRow',
    'height',
    'justifyContent',
    'marginTop',
    'maxHeight',
    'maxWidth',
    'minHeight',
    'nowrap',
    'position',
    'relative',
    'spaceBetween',
    'textCenter',
    'wide',
    'width',
    'width',
    'withBorder',
    'wrap',
    'zIndex',
  ]);
  return !propsSet.has(name);
};

export const styledConfig = { shouldForwardProp };
